import { Routes, Route, Navigate } from 'react-router-dom';
import Hero from './sections/Hero';
import WhatWeDo from './sections/WhatWeDo';
import CoreCapabilities from './sections/CoreCapabilities';
import Footer from './sections/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import TermsOfService from './pages/TermsOfService';
import Pricing from './pages/Pricing';
import {
  AuthProvider,
  AppRightsProvider,
  AdminLayout,
  ProtectedRoute,
  LoginPage,
  RegisterPage,
  DashboardPage,
  TopUpPage,
  BillingPage,
  ApplicationsPage,
  PaymentRecordsPage,
  PayReportPage,
  ApiDocsPage,
} from './admin';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-black">
      <main>
        <Hero />
        <WhatWeDo />
        <CoreCapabilities />
      </main>
      <Footer />
    </div>
  );
};

const AdminRoutes: React.FC = () => {
  return (
    <AuthProvider>
      <AppRightsProvider>
        <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <DashboardPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="top-up"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <TopUpPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="billing"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <BillingPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="applications"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ApplicationsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="applications/payment-report"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <PayReportPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="applications/payment-records"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <PaymentRecordsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        {/* 兼容旧地址 */}
        <Route path="payment-report" element={<Navigate to="/admin/applications/payment-report" replace />} />
        <Route path="payments" element={<Navigate to="/admin/applications/payment-records" replace />} />
        <Route
          path="api-docs"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ApiDocsPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
      </AppRightsProvider>
    </AuthProvider>
  );
};

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/refund" element={<RefundPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/admin/*" element={<AdminRoutes />} />
    </Routes>
  );
};

export default App;